<template>
    
    <div class="container">
        <h1>AHU Formate</h1>
        <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-10">
            <img src="@/images/reports/ahu/ahu1.jpg" alt="">
            <p>AHU</p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-10">
            <img src="@/images/reports/ahu/ahu2.jpg" alt="">
            <p>AHU</p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-10">
            <img src="@/images/reports/ahu/dt.jpg" alt="">
            <p>DT Rec(Return)</p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-10">
            <img src="@/images/reports/ahu/supply1.jpg" alt="">
            <p>Supply</p>
        </div>
        </div>

    </div>
</template>
<style lang="scss" scoped>
h1{
    text-transform: uppercase;
    color:#075daa;
    margin-bottom: 15px;
}
p{
    text-align: center;
    color: red;
}
div img {
    width:100%;
}
img{
     border: 5px solid #555;
}
</style>
